/* eslint-disable @typescript-eslint/naming-convention */

export interface Landlord {
  id?: number
  code?: string
  full_name?: string
}

export function newLandlord (data?: Partial<Landlord>): Landlord {
  return {
    ...data,
  }
}
